/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
const getProjectString = (storeDistricts) => {
  const group = {};
  const objectArray = Object.values(storeDistricts);

  objectArray.forEach((item) => {
    if (!group[item.project_id]) {
      group[item.project_id] = [];
    }
    group[item.project_id].push(item.district_id);
  });

  let result = '';
  for (const project_id in group) {
    result += `${project_id}:${group[project_id].join(',')};`;
  }

  return result.slice(0, -1);
};

export { getProjectString as default };
